import { Add16 } from '@carbon/icons-react';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Task } from 'api/tasks';
import {
  AddItemButton,
  AddItemWrapper,
  AddTask,
  SectionName,
  SectionWrapper,
  TitleWrapper,
} from './components';

interface Props {
  task: Task;
}

export const CpTaskMoreDetailsSection: React.FC<Props> = ({ task }) => {
  const showAttachments = useMemo(
    () => !task?.attachments || task?.attachments.length === 0,
    [task?.attachments],
  );

  const showSubTasks = useMemo(
    () => !task?.subTasks || task?.subTasks.length === 0,
    [task?.subTasks],
  );

  const showDependentTasks = useMemo(
    () => !task?.dependentTasks || task?.dependentTasks.length === 0,
    [task?.dependentTasks],
  );

  if (!showAttachments && !showSubTasks && !showDependentTasks) {
    return <></>;
  }

  return (
    <SectionWrapper>
      <TitleWrapper>
        <SectionName>
          <FormattedMessage id="More" />
        </SectionName>
      </TitleWrapper>
      {showAttachments ? (
        <AddItemWrapper withTopMargin>
          <Add16 />
          <AddItemButton>
            <FormattedMessage id="attachment.add" />
          </AddItemButton>
        </AddItemWrapper>
      ) : (
        <></>
      )}
      {showSubTasks ? (
        <AddItemWrapper withTopMargin>
          <Add16 />
          <AddItemButton>
            <AddTask>
              <FormattedMessage id="sub_tasks.add" />
            </AddTask>
          </AddItemButton>
        </AddItemWrapper>
      ) : (
        <></>
      )}
      {/* {showDependentTasks ? (
        <AddItemWrapper withTopMargin>
          <Add16 />
          <AddItemButton>
            <FormattedMessage id="dependent_tasks.add" />
          </AddItemButton>
        </AddItemWrapper>
      ) : (
        <></>
      )} */}
    </SectionWrapper>
  );
};
